import { PROCESS } from "../../lib/content";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-cursive text-gold text-2xl md:text-3xl">Simple & Stress-Free</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-1">How It Works</h2>
          <div className="gold-divider w-40 mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {PROCESS.map((p, i) => (
            <div key={p.step} data-testid={`process-step-${p.step}`} className="relative">
              <span className="font-serif text-6xl font-bold text-gold/15">{p.step}</span>
              <h3 className="font-serif text-xl text-white -mt-6 relative">{p.title}</h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">{p.desc}</p>
              {i < PROCESS.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-4 w-8 h-px bg-gold/30" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
